// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1kaNY","path":"_3OfIg"};